import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Buttons';
import SectionTitle from 'components/SectionTitle';
import { ComponentDetailsModel } from 'models/certificate.model';

import { componentConfig, ComponentConfigModel } from './componentConfig';

const ComponentInformation = (data: ComponentDetailsModel) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { componentPassportId } = data;

  return (
    <>
      <SectionTitle>
        <Row justify="space-between" align="middle">
          {t('certificate.componentInformation')}
          {componentPassportId && (
            <Button
              type="link"
              onClick={() => navigate(`/home/certificates/${componentPassportId}`)}
            >
              {t(`certificate.goToCertificate`)}
            </Button>
          )}
        </Row>
      </SectionTitle>
      <Row>
        {componentConfig.map(({ id, suffix }: ComponentConfigModel) => (
          <React.Fragment key={id}>
            <Col md={12} lg={6} style={{ marginBottom: '8px' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                {t(`certificate.component.${id}.label`)}
              </div>
            </Col>
            <Col md={12} lg={6}>
              {data[id] ? data[id] + suffix : ''}
            </Col>
          </React.Fragment>
        ))}
      </Row>
    </>
  );
};

export default ComponentInformation;
